import { Navigation } from '@/components/Navigation';
import { BackButton } from '@/components/BackButton';
import { SEO } from '@/components/SEO';
import { ReferralDashboard } from '@/components/referral/ReferralDashboard';
import { ApplyReferralCode } from '@/components/referral/ApplyReferralCode';
import { ContactShare } from '@/components/referral/ContactShare';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

export default function Referrals() {
  return (
    <div className="min-h-screen bg-background">
      <SEO 
        title="Referrals - Invite Friends & Earn Rewards"
        description="Share your referral code and earn 1% from your friends' spending for 3 months"
        keywords={['referral program', 'earn rewards', 'invite friends', 'bonus']}
      />
      <Navigation />
      
      <div className="container py-8">
        <BackButton to="/" />
        
        <div className="mb-8">
          <h1 className="text-4xl font-bold mb-2">Referral Program</h1>
          <p className="text-muted-foreground text-lg">
            Invite friends and earn rewards from their activity
          </p>
        </div>

        <Tabs defaultValue="dashboard" className="space-y-6">
          <TabsList className="grid w-full max-w-md grid-cols-3">
            <TabsTrigger value="dashboard">Dashboard</TabsTrigger>
            <TabsTrigger value="apply">Apply Code</TabsTrigger>
            <TabsTrigger value="share">Share</TabsTrigger>
          </TabsList>

          <TabsContent value="dashboard">
            <ReferralDashboard />
          </TabsContent>

          <TabsContent value="apply">
            <ApplyReferralCode />
          </TabsContent>

          <TabsContent value="share">
            <ContactShare />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
